import {selectDefaultParams} from "./selectDefaultParams";

export const selectDebugFlag = (state) => selectDefaultParams(state).debug
